// import {Node, State} from '../types';
import * as _ from 'lodash';
import { config } from '../config'

/**
 * @param {string} key
 * @param {Object} thisProps
 * @param {Object} nextProps
 */
export const hasPropChanged = (thisProps: object, nextProps: object) => thisProps !== nextProps;

// export const isAuthenticated = (state: State) => !!state.auth.token;
// export const getAuthToken = (state: State) => state.auth.token;

export const getServerHost = () : string => {
    if (typeof(Storage) !== "undefined" && localStorage.getItem('serverHost')) {
        return localStorage.getItem('serverHost') || ''
    }

    return config.serverHost
};
export const getMediaServer = () : string => {
   

    return config.mediaServer
};

export const getDefaultServerHost = () : string => {
    return config.serverHost
};

export const getViolationListType = () : string => {
    if (typeof(Storage) !== undefined) {
        return localStorage.getItem('violationListType') || 'history';
    }

    return 'history';
};

export const setViolationListType = (listType: string) => {
    if (typeof(Storage) !== undefined) {
        localStorage.setItem('violationListType', listType)
    }
};

export const getSelectedItemId = () : string => {
    if (typeof(Storage) !== undefined) {
        return localStorage.getItem('selectedItemId') || '';
    }

    return '';
};

export const setSelectedItemId = (itemId: string) => {
    if (typeof(Storage) !== undefined) {
        localStorage.setItem('selectedItemId', itemId)
    }
};

export const setCookie = (cname: string, cvalue: string|null, exdays: number = 1) => {
    const now = new Date();
    now.setTime(now.getTime() + (exdays * 86400 * 1000));
    const expires = "expires="+now.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  
export const getCookie = (cname: string) => {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

export const deleteCookie = (cname: string) => {
    document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';  
}
const SPACE: number = 2
export const toJson = (target: any): string =>
    JSON.stringify(target, null, SPACE);

let camId: string|null = "";
if(window.localStorage.getItem('camId'))
        camId = window.localStorage.getItem('camId');
// sending token as query param becasue SSE doesn't support custom headers uptill May 7, 2020
const token = getCookie("auth_token")
export const currentVersionUrl = `${getServerHost()}/v0-1`;
export const eventSource = new EventSource(`${currentVersionUrl}/dashboard-updates?camId=${camId}&token=${token}`)



// WEBPACK FOOTER //
// ./src/utils/utils.ts